import { useDispatch, useSelector } from "react-redux";
import { Alert, Snackbar } from '@mui/material';
import { clear } from "../../apis/reducers/snackbarsReducer";
import { RootState } from "../../apis/store";


const SnackbarMessage = () => {
    const dispatch = useDispatch();
    const { snackbarOpen, snackbarMessage, messageType, position } = useSelector((state: RootState) => state.snackbars);

    const handleClose = () => {
        dispatch(clear());
    }

    return (
        <Snackbar
            anchorOrigin={{
                vertical: position,
                horizontal: "center"
            }}
            open={snackbarOpen}
            autoHideDuration={4000}
            resumeHideDuration={2000}
            onClose={handleClose}
        >
            {messageType === "error" || messageType === "success" || messageType === "info" || messageType === "warning" ?
                <Alert onClose={handleClose} severity={messageType}>
                    {snackbarMessage}
                </Alert> : <></>
            }
        </Snackbar>
    );
}

export default SnackbarMessage;